export function safeBigInt(value?: string | null): bigint {
  try {
    return BigInt(value ?? '0')
  } catch {
    return 0n
  }
}

export function isPositiveAtomic(value?: string): boolean {
  return safeBigInt(value) > 0n
}

export function addAtomic(a?: string, b?: string): string {
  return (safeBigInt(a) + safeBigInt(b)).toString()
}

export function sumAtomic(values: Array<string | undefined | null>): string {
  return values.reduce<string>(
    (acc, v) => (safeBigInt(acc) + safeBigInt(v ?? '0')).toString(),
    '0',
  )
}

export function multiplyAtomic(a?: string | null, b?: string | null): string {
  try {
    const x = BigInt(a ?? '0')
    const y = BigInt(b ?? '0')
    if (x <= 0n || y <= 0n) return '0'
    return (x * y).toString()
  } catch {
    return '0'
  }
}
